import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useState } from 'react';
import AutocompleteItemComponent from 'src/common-ui/autocomplete/autocomplete-item/autocomplete-item.component';
import { AutoCompleteUtils } from 'src/utils/autocomplete.utils';
export const AutocompleteBox = ({ autoCompleteValues, translateSimpleAutoCompleteValues, handleOnChange, value, }) => {
    const [filteredValues, setFilteredValues] = useState([]);
    useEffect(() => {
        if (autoCompleteValues) {
            const lowerCaseSearchValue = String(value).toLowerCase();
            if (!!autoCompleteValues.categories) {
                setFilteredValues({
                    categories: AutoCompleteUtils.filterCategoriesList(autoCompleteValues, lowerCaseSearchValue),
                });
            }
            else if (typeof autoCompleteValues.at(0) === 'string') {
                setFilteredValues(AutoCompleteUtils.filterStringList(autoCompleteValues, lowerCaseSearchValue));
            }
            else {
                setFilteredValues(AutoCompleteUtils.filterValuesList(autoCompleteValues, lowerCaseSearchValue));
            }
        }
    }, [value, autoCompleteValues]);
    const renderList = (autoCompleteValues) => {
        if (!!autoCompleteValues.categories) {
            return (React.createElement("div", { className: "autocomplete-panel" }, filteredValues.categories.map((category) => category.values.length > 0 && (React.createElement("div", { className: "category", key: category.title },
                React.createElement("span", { className: "title" }, category.translateTitle
                    ? getMessage(category.title)
                    : category.title),
                category.values.map((autoCompleteItem, index) => (React.createElement(AutocompleteItemComponent, { key: `item-${index}`, value: autoCompleteItem.value, translateValue: autoCompleteItem.translateValue, onItemClick: handleOnChange, subLabel: autoCompleteItem.subLabel, translateSublabel: autoCompleteItem.translateSubLabel }))))))));
        }
        else if (typeof autoCompleteValues.at(0) === 'string') {
            return (React.createElement("div", { className: "autocomplete-panel" },
                filteredValues.map((item, index) => (React.createElement(AutocompleteItemComponent, { key: `item-${index}`, value: item, translateValue: translateSimpleAutoCompleteValues, onItemClick: handleOnChange }))),
                ' '));
        }
        else {
            return (React.createElement("div", { className: "autocomplete-panel" }, filteredValues.map((item, index) => (React.createElement(AutocompleteItemComponent, { key: `item-${index}`, value: item.value, translateValue: item.translateValue, subLabel: item.subLabel, translateSublabel: item.translateSubLabel, onItemClick: handleOnChange })))));
        }
    };
    return renderList(filteredValues);
};
